import * as React from "react";
import { makeStyles } from "@material-ui/core";

import { Image } from "components";

import { Header3 } from "./Header3";

const useStyles = makeStyles(theme => ({
  container: {
    "& > div:nth-of-type(2)": {
      flexGrow: 1,
    },
    [theme.breakpoints.down("xs")]: {
      margin: theme.spacing(0, 2),
      flexWrap: "wrap",
      "&&#header3-container > div:nth-child(1)": {
        justifyContent: "flex-start",
      },
      "&&#header3-container > div:nth-child(2)": {
        justifyContent: "flex-end",
      },
      "&&#header3-container > div:nth-child(3)": {
        flexBasis: "100%",
        justifyContent: "center",
        marginTop: theme.spacing(1),
      },
    },
  },
}));

interface Props {
  onClick?: () => void;
  backText?: string;
  right?: React.ReactNode;
}

export function BackButtonLogoHeader(props: Props) {
  const { backText, onClick, right } = props;
  const classes = useStyles();

  return (
    <>
      <Header3
        className={classes.container}
        left={
          backText &&
          onClick && (
            <span className="header-back-button">
              <span onClick={onClick}>
                <i
                  className="fa fa-angle-left"
                  style={{ marginRight: "10px" }}
                  aria-hidden="true"
                />
                <label
                  id="back-to-account-header"
                  className="back-to-account-header"
                >
                  {backText}
                </label>
              </span>
            </span>
          )
        }
        center={
          <Image
            alt="Royalty Exchange - Know Your Worth (beta)"
            name="orderbook/kyw_logo.svg"
            className="header-kyw-logo"
          />
        }
        right={right}
      />
    </>
  );
}
